import React from 'react';
import { classes, style } from 'typestyle';
import { ArtistSchema } from '../../../types/schema';
import { percent, px } from 'csx';
import { mixinTextEllipsis } from '../../../theme/mixin';
import { UtmLink } from '../atoms/UtmLink';
import { mediaDesktop, mediaUpToDesktop } from '../utilities/mediaQueries';
import { colorBlack, rebrand } from '../../../theme/color';
import { zLabel } from '../../../theme/z';
import { ArtistProfileImage } from './ArtistProfileImage';
import { resetAnchorStyles } from '../../../theme/reset';
import { spacing } from '../../../theme/spacing';

const styles = {
  wrapper: style({
    position: 'relative',
  }),
  artistInfo: style({
    marginTop: spacing.XSMALL,
    width: percent(100),
    $nest: {
      '& a': {
        ...resetAnchorStyles,
      },
      '& a:hover': {
        textDecoration: 'underline',
      },
    },
  }),
  artistInfoLargeSpaced: style({
    marginTop: spacing.SMALL,
  }),
  name: style(mixinTextEllipsis, {
    display: 'block',
    fontWeight: 700,
    color: rebrand.contrast[50].toString(),
  }),
  type: style({
    fontWeight: 400,
    color: rebrand.neutralOnLight[70].toString(),
  }),
};

export type ArtistTileProps = {
  className?: string;
  artist: ArtistSchema;
  isSearchPage?: boolean;
  onClick?: () => void;
};

export const ArtistTile: React.FC<ArtistTileProps> = ({
  children,
  className,
  artist,
  isSearchPage = false,
  onClick,
}) => {
  return (
    <div onClick={onClick} className={classes(styles.wrapper, className)}>
      <ArtistProfileImage artist={artist} isLink />

      <div className={classes(styles.artistInfo, isSearchPage && styles.artistInfoLargeSpaced)}>
        <UtmLink
          href={`/music/artists/${artist.slug}`}
          {...(isSearchPage && { 'data-test-top-solution-text-link': 'artist' })}
        >
          <span className={styles.name}>{artist.name}</span>
        </UtmLink>
        {isSearchPage && <span className={styles.type}>Artist</span>}
      </div>
    </div>
  );
};
